// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { AnalyticsEvent, logEvent, EventParams } from '@weddingspot/ws-analytics';
import { ReviewCard } from '@weddingspot/ws-core-components';
import { VendorsApi } from '@weddingspot/ws-api-client';
import Modal from '@cvent/carina/components/Modal';
import { Button as WSButton } from '../../../../ui/Button';
import { VenueProfileContext } from '../../../context';
import styles from '../Reviews.module.scss';
import Header from './Header';
import Footer from './Footer';
import { ApprovalStatus, ModalFormat, REVIEW_BATCH_SIZE, SCREEN_WIDTH_BREAKPOINT, SortOrder, Z_INDEX } from '../constant';

const ViewAll: React.FC = () => {
    const { reviews, venueId, setReviews, wsVenueProfile } = React.useContext(VenueProfileContext);
    const [isOpen, setIsOpen] = useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    const shouldLoad = () => {
        const reviewsLoaded = reviews.data.length;
        if (reviewsLoaded === reviews.totalCount) {
            return false;
        }
        const reviewsList = document.getElementById('reviewList');
        const reviewsListTop = reviewsList.getBoundingClientRect().top;
        const reviewsListBottom = reviewsList.getBoundingClientRect().bottom;
        const secondLastReview = document.getElementById('reviewList').children[reviewsLoaded - 2];
        const secondLastReviewTop = secondLastReview.getBoundingClientRect().top;
        const secondLastReviewBottom = secondLastReview.getBoundingClientRect().bottom;

        if (secondLastReviewTop > reviewsListBottom) {
            return false;
        }
        if (secondLastReviewBottom < reviewsListTop) {
            return false;
        }
        return true;
    };

    const loadReviews = () => {
        const queryParam = {
            approval_statuses: ApprovalStatus.APPROVED,
            offset: reviews.data.length,
            size: REVIEW_BATCH_SIZE,
            sort_order: SortOrder.DESCENDING,
        };
        VendorsApi.getReviews(venueId, queryParam).then((res) => {
            setReviews({ ...reviews, data: [...reviews.data, ...res.data] });
        });
    };

    useEffect(() => {
        // Resize event listener is used to determine whether Small or Medium sized Modal is to be used
        window.addEventListener('resize', () => {
            setScreenWidth(window.innerWidth);
        });
        // This useEffect call handles case when there are spaces left after loading 4 reviews and
        // needs to load further more reviews.
        if (shouldLoad) {
            loadReviews();
        }
    }, []);

    const scrollHandler = () => {
        if (shouldLoad()) {
            loadReviews();
        }
    };

    const onClickhandler = () => {
        setIsOpen(true);
        logEvent(AnalyticsEvent.EVTNM_SHOWN_ALL_REVIEWS, {
            source: 'venue profile page',
            version: 3,
            [EventParams.VENUE_ID]: venueId,
        });
    };

    return (
        <>
            <WSButton
                style='lined'
                onClick={onClickhandler}
            >
                View All
            </WSButton>
            <Modal
                format={screenWidth > SCREEN_WIDTH_BREAKPOINT ? ModalFormat.MEDIUM : ModalFormat.SMALL}
                isOpen={isOpen}
                zIndex={Z_INDEX}
            >
                <div className={styles.viewAll__ModalChild}>
                    <Header
                        setIsOpen={setIsOpen}
                        venueName={wsVenueProfile.name}
                        totalCount={reviews.totalCount}
                        overallRating={reviews.overallRating}
                    />
                    <div id='reviewList' className={styles.viewAll__reviews} onScroll={scrollHandler}>
                        {reviews.data.map(({ review, rating }, index) => (
                            <ReviewCard key={review.reviewId} review={review} rating={rating} isLast={index == reviews.data.length - 1} />
                        ))}
                    </div>
                    <Footer setIsOpen={setIsOpen} />
                </div>
            </Modal>
        </>
    );
};

export default ViewAll;
